import useFetchByParams from 'shared/hooks/useFetchByParams';
import { useMemo } from 'react';
import { fetchPriceTypes, selectPriceTypes, selectPriceTypesLoading } from 'features/products/store/price.slice';
import { QueryParams } from 'shared/types';
import type { PriceType } from 'features/products/models';

export const usePriceTypesQuery = (query?: QueryParams) => {
  return useMemo(() => {
    const queryParams = { ...query };

    return [queryParams];
  }, []);
};

export const usePriceTypes = (query: QueryParams) => {
  return useFetchByParams<PriceType[]>({
    action: fetchPriceTypes,
    dataSelector: selectPriceTypes,
    loadingSelector: selectPriceTypesLoading,
    params: query,
  });
};
